import styled from 'styled-components';

export const StyledNoResults = styled.div`
  display: flex;
  padding: 30px 0 20px 0;
  color: var(--whiteGRG);
  opacity: 0.5;
  justify-content: center;
`;
